import { useCheckPermissionsArray } from "@/shared";
import SaveProspecto from "../componente/SaveProspecto/SaveProspecto";
import { PermissionsEnum } from "@/auth/interfaces";

export default function CreateProspectoPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_add_prospecto,
    PermissionsEnum.api_view_plan,//toca quitar, parece que no se necesita
    PermissionsEnum.api_add_solicitudextrangeroprospecto
  ]);
  
  return (
    <SaveProspecto />
  )

}